import { createAction } from '@reduxjs/toolkit';

import { AppThunkDispatch } from '../store';
import {
  AssignedWorkflow,
  AssignedWorkflowsQueryParams,
  AvailableWorkflowTemplate,
  WORKFLOW_IN_PROGRESS,
  WORKFLOW_NOT_STARTED,
} from 'data/models/Workflows';
import { deleteAssignedWorkflow, fetchAssignedWorkflows, fetchAvailableWorkflowTemplates } from 'data/data-layer/workflows';

const LOAD_AVAILABLE_WORKFLOW_TEMPLATES = 'LOAD_AVAILABLE_WORKFLOW_TEMPLATES';
const AVAILABLE_WORKFLOW_TEMPLATES_LOADING = 'AVAILABLE_WORKFLOW_TEMPLATES_LOADING';
const ASSIGNED_WORKFLOWS_LOADING = 'ASSIGNED_WORKFLOWS_LOADING';
const LOAD_ASSIGNED_WORKFLOWS = 'LOAD_ASSIGNED_WORKFLOWS';
const UPDATE_ASSIGNED_WORKFLOWS = 'UPDATE_ASSIGNED_WORKFLOWS';
const DELETE_ASSIGNED_WORKFLOW = 'DELETE_ASSIGNED_WORKFLOW';
const RESET_AVAILABLE_WORKFLOW_TEMPLATES = 'RESET_AVAILABLE_WORKFLOW_TEMPLATES';
const RESET_WORKFLOWS = 'RESET_WORKFLOWS';
const LOAD_HOUSEHOLD_HEADER_ASSIGNED_WORKFLOWS = 'LOAD_HOUSEHOLD_HEADER_ASSIGNED_WORKFLOWS';
const HOUSEHOLD_HEADER_ASSIGNED_WORKFLOWS_LOADING = 'HOUSEHOLD_HEADER_ASSIGNED_WORKFLOWS_LOADING';

export const loadAvailableWorkflowTemplatesAction = createAction<AvailableWorkflowTemplate[]>(LOAD_AVAILABLE_WORKFLOW_TEMPLATES);
export const loadAssignedWorkflowsAction = createAction<AssignedWorkflow[]>(LOAD_ASSIGNED_WORKFLOWS);
export const updateAssignedWorkflowsAction = createAction<AssignedWorkflow>(UPDATE_ASSIGNED_WORKFLOWS);
export const removeAssignedWorkflowAction = createAction<number>(DELETE_ASSIGNED_WORKFLOW);
export const setAvailableWorkflowTemplatesLoading = createAction<boolean>(AVAILABLE_WORKFLOW_TEMPLATES_LOADING);
export const setAssignedWorkflowsLoading = createAction<boolean>(ASSIGNED_WORKFLOWS_LOADING);
export const loadHouseholdHeaderAssignedWorkflowsAction = createAction<AssignedWorkflow[]>(LOAD_HOUSEHOLD_HEADER_ASSIGNED_WORKFLOWS);
export const setHouseholdHeaderAssignedWorkflowsLoading = createAction<boolean>(HOUSEHOLD_HEADER_ASSIGNED_WORKFLOWS_LOADING);
export const resetAvailableWorkflowTemplatesAction = createAction(RESET_AVAILABLE_WORKFLOW_TEMPLATES);
export const resetWorkflowsStateAction = createAction(RESET_WORKFLOWS);

export const loadAvailableWorkflowTemplates =
  (householdQid: string) =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    dispatch(setAvailableWorkflowTemplatesLoading(true));
    const workflowTemplates: AvailableWorkflowTemplate[] = await fetchAvailableWorkflowTemplates(householdQid, dispatch);
    dispatch(loadAvailableWorkflowTemplatesAction(workflowTemplates));
    dispatch(setAvailableWorkflowTemplatesLoading(false));
  };

export const loadAssignedWorkflows =
  (queryParams: AssignedWorkflowsQueryParams) =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    dispatch(setAssignedWorkflowsLoading(true));
    const assignedWorkflows: AssignedWorkflow[] = await fetchAssignedWorkflows(queryParams, dispatch);
    dispatch(loadAssignedWorkflowsAction(assignedWorkflows));
    dispatch(setAssignedWorkflowsLoading(false));
  };

export const removeAssignedWorkflow =
  (AssignedWorkflowId: number) =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    const deletedAssignedWorkflow = await deleteAssignedWorkflow(AssignedWorkflowId, dispatch);
    if (deletedAssignedWorkflow) {
      dispatch(removeAssignedWorkflowAction(AssignedWorkflowId));
    }
  };

export const resetAvailableWorkflowTemplates =
  () =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    dispatch(resetAvailableWorkflowTemplatesAction());
  };

export const loadHouseholdHeaderAssignedWorkflows =
  (householdQid: string) =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    dispatch(setHouseholdHeaderAssignedWorkflowsLoading(true));
    const queryParams: AssignedWorkflowsQueryParams = {
      householdQid,
      status: [WORKFLOW_NOT_STARTED, WORKFLOW_IN_PROGRESS].toString(),
    };
    const assignedWorkflows: AssignedWorkflow[] = await fetchAssignedWorkflows(queryParams, dispatch);
    dispatch(loadHouseholdHeaderAssignedWorkflowsAction(assignedWorkflows));
    dispatch(setHouseholdHeaderAssignedWorkflowsLoading(false));
  };

export const resetWorkflowsState =
  () =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    dispatch(resetWorkflowsStateAction());
  };
